export const productsByTable = {
	label: "Products sold by table",
};
